import { Video } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from '@tanstack/react-router';
import { useGetChatCredentials } from '@/hooks/chat/useGetChatCredentials';
import { useStreamVideoClient } from '@stream-io/video-react-sdk';
import { useVideoCallLogger } from '@/hooks/useVideoCallLogger';
import { reportError } from '@/utils/errorReporter';
import { useGetVideoCallProvider } from '@/hooks/videocall/useGetVideoCallProvider';

export const VideoCallButton = () => {
  const navigate = useNavigate();
  const { data } = useGetChatCredentials();
  const videoClient = useStreamVideoClient();
  const logger = useVideoCallLogger();

  const { data: videoCallProvider } = useGetVideoCallProvider();

  // we only offer the client to initiate videocalls if the provider is Stream
  // (as Google Meets can only be setup by the psychologists from the Dashboard)
  if (!videoCallProvider || videoCallProvider.provider === 'GoogleMeets') {
    return null;
  }

  return (
    <Button
      disabled={!data || !videoClient}
      onClick={async () => {
        const callId = `csb-${data!.channelId}-1`;

        const myCall = videoClient!.call('default', callId);

        await myCall.join({
          create: true,
          ring: false,
        });

        try {
          if (logger.collectDeviceInformation) {
            const deviceInfo = await logger.collectDeviceInformation();
            logger.logCallStart({
              call_id: callId,
              call_type: 'default',
              channel_id: data?.channelId ?? undefined,
              ...deviceInfo,
            });
          }
        } catch (error) {
          reportError(error);
        }

        navigate({ to: '/auth/video/call' });
      }}
      data-testid="video-call-button"
    >
      <div className="w-5 h-5">
        <Video className="w-5 h-5" />
      </div>
    </Button>
  );
};
